import React, { useState } from 'react';
import { Button, DatePicker, Form, FormField, FormFieldLabel, Select } from '../../ui'
import './style.css';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectCustomer, setSearchType } from '../../redux/slices/customer-slice';
import { Navigate } from 'react-router-dom';
import { FilterByDateRange } from '../../redux/slices/types';
import { FilterTripServiceProviderTypes, TripServiceProvider, TripServiceProviderKeys } from '../details-view/payments-data/types';
import { fetchPaymentsData, selectPaymentsStore } from '../../redux/slices/payments-slice';
import { resetErrorDialog, selectNotificationStore, setErrorDialog } from '../../redux/slices/notification-slice';
import { BillingEntryState, BillingEntryStateKeys, FilterBillingEntryState } from '../../utils/trip-invoice-utils';

export default function SearchPaymentForm() {
  const dispatch = useAppDispatch();
  const customer = useAppSelector(selectCustomer());
  const notification = useAppSelector(selectNotificationStore());
  const paymentsStore = useAppSelector(selectPaymentsStore());

  const [dateRange, setDateRangeFilter] = useState({
    start: '',
    stop: ''
  });
  const [paymentState, setPaymentStateFilter] = useState(null);
  const [serviceProvider, setServiceProviderfilter] = useState(null);
  const [queryParams, setQueryParams] = useState('');

  function setDateRange(dateRange: FilterByDateRange) {
    setDateRangeFilter(dateRange);
    dispatch(resetErrorDialog());
  }

  function setPaymentState(paymentState: FilterBillingEntryState) {
    setPaymentStateFilter(paymentState);
    dispatch(resetErrorDialog());
  }

  function setServiceProvider(serviceProvider: FilterTripServiceProviderTypes) {
    setServiceProviderfilter(serviceProvider);
    dispatch(resetErrorDialog());
  }

  function handleOnDateRangeChange(e) {
    if (e.includes('bis')) {
      const SPLIT_FLAG = ' bis ';
      const dates = e.split(SPLIT_FLAG);
      setDateRange({
        start: dates[0],
        stop: dates[1],
      })

    }
  }

  const navigateToPaymentDetails = (e: any) => {
    e.preventDefault()

    if (!paymentState) {
      dispatch(setErrorDialog({
        code: 'MISSING_PAYMENT_SEARCH_FIELD',
        title: 'Unable to search',
        message: 'Payments searach not possible, select valid payment state.'
      }));
      return;
    }

    dispatch(setSearchType({ type: 'PAYMENT' }));
    dispatch(resetErrorDialog(undefined));

    const params = new URLSearchParams();
    if (paymentState) {
      params.append('state', paymentState);
    }
    if (serviceProvider) {
      params.append('msp', serviceProvider);
    }
    if (dateRange?.start && dateRange?.stop) {
      params.append('start', dateRange?.start);
      params.append('stop', dateRange?.stop);
    }

    setQueryParams(params.toString())

    dispatch(fetchPaymentsData({
      paymentState,
      serviceProvider,
      formDate: dateRange.start,
      toDate: dateRange.stop
    }))
  };

  return (
    <Form floatingLabel testId="searchForm" onSubmit={navigateToPaymentDetails}>
      <p>Search for Payments</p>
      <FormField
        labelText="Select Payment State"
        type="input"
        testId='testSelectPaymentState'
      >
        <Select testId='testSelectPaymentSelect' onChange={(e) => setPaymentState(e.target.value as FilterBillingEntryState)} value={paymentState || undefined}>
          <Select.Item value={''}>None</Select.Item>
          {BillingEntryStateKeys.map(key => <Select.Item key={key} value={key}>{BillingEntryState[key]}</Select.Item>)}
        </Select>
      </FormField >

      <FormField
        labelText="Select Date Range"
        type="input"
        testId='testSelectDateRange'
      >
        <div style={{ margin: 'auto' }}>
          <DatePicker
            testId='testDatePicker'
            key="paymentsDataRangeSelect"
            mode='range'
            onChange={handleOnDateRangeChange}
          />
        </div>
      </FormField>

      <FormField
        labelText="Select Service Provider"
        type="input"
        testId='testSelectMSP'
      >
        <Select onChange={(e) => setServiceProvider(e.target.value as FilterTripServiceProviderTypes)} value={serviceProvider || undefined}>
          <Select.Item value={''}>None</Select.Item>
          {TripServiceProviderKeys.map(key => <Select.Item key={key} value={TripServiceProvider[key]}>{TripServiceProvider[key]}</Select.Item>)}
        </Select>
      </FormField >

      <FormField
        style={{ paddingTop: '7px' }}
        type="input"
      >
        <Button
          onClick={navigateToPaymentDetails}
          key="applyFilters"
          testId='testApplyFiltersBtn'
        >
          Search
        </Button>
      </FormField >
      {notification?.errorDialog?.code === 'MISSING_PAYMENT_SEARCH_FIELD' && <FormFieldLabel testId="noPayment" className='Error'>Payments searach not possible, select valid payment state.</FormFieldLabel>}

      {paymentsStore?.list && customer.search.type === 'PAYMENT' && <Navigate to={`/payments?${queryParams ? queryParams : ''}`} replace={true} />}
    </Form>
  )
}
